module.exports = __webpack_public_path__ + "static/U16_logo-32f987e4966966a990dfa4cfd99e6738.png";